import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    fill?: string;
    width?: number;
    height?: number;
};

export const MarkerIcon = ({ fill = 'currentColor', width = 80, height = 80, ...props }: Props) => {
    const { scaleWidthPixel, scaleHeightPixel } = useScreenSize();
    return (
        <svg width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 80 80" fill={fill} xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M17 33.4995C17 21.0731 26.8497 10.9995 39 10.9995C51.1503 10.9995 61 21.0731 61 33.4995C61 49.6736 39.0063 70.9934 39 70.9995C38.9973 70.9969 17 49.6749 17 33.4995ZM19.4004 33.4995C19.4004 37.0354 20.6136 41.0266 22.5986 45.1401C24.5716 49.2284 27.2269 53.2754 29.9219 56.8784C32.6115 60.4742 35.307 63.5825 37.332 65.7935C37.9596 66.4787 38.524 67.0749 39 67.5728C39.476 67.0749 40.0404 66.4787 40.668 65.7935C42.693 63.5825 45.3885 60.4742 48.0781 56.8784C50.7731 53.2754 53.4284 49.2284 55.4014 45.1401C57.3864 41.0266 58.5996 37.0354 58.5996 33.4995C58.5996 22.3475 49.7742 13.3999 39 13.3999C28.2258 13.3999 19.4004 22.3475 19.4004 33.4995ZM30 33.9995C30 29.0289 34.0294 24.9995 39 24.9995C43.9706 24.9995 48 29.0289 48 33.9995C48 38.9701 43.9706 42.9995 39 42.9995C34.0294 42.9995 30 38.9701 30 33.9995ZM39 40.5991C42.6451 40.5991 45.5996 37.6446 45.5996 33.9995C45.5996 30.3544 42.6451 27.3999 39 27.3999C35.3549 27.3999 32.4004 30.3544 32.4004 33.9995C32.4004 37.6446 35.3549 40.5991 39 40.5991Z"
                fill={fill}
            />
        </svg>
    );
};
